import { useEffect } from 'react';

/**
 * Keeps `--app-height` on <html> equal to the visible viewport's height, which the app shell
 * sizes itself to. On iOS the on-screen keyboard overlays the page without resizing it (dvh
 * doesn't shrink), so a bottom-anchored composer — the discussion's — would sit behind the
 * keyboard; the visual viewport is the one measure that does shrink. Pinch-zoom also shrinks it,
 * so updates are skipped while zoomed in.
 */
export function useVisualViewportHeight(): void {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const root = document.documentElement;

    const update = () => {
      if (Math.abs(viewport.scale - 1) > 0.01) return;
      root.style.setProperty('--app-height', `${Math.round(viewport.height)}px`);
      // iOS still pans the page up to reveal a focused field; with the shell already shrunk to
      // fit above the keyboard, that pan only shoves the top bar off-screen.
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    };

    update();
    viewport.addEventListener('resize', update);
    return () => {
      viewport.removeEventListener('resize', update);
      root.style.removeProperty('--app-height');
    };
  }, []);
}
